import { render, staticRenderFns } from "./Totop.vue?vue&type=template&id=625e1a6f&"
import script from "./Totop.vue?vue&type=script&lang=js&"
export * from "./Totop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports